module.exports = __webpack_public_path__ + "static/img/certificate_get.2b943dd6.png";